import { render, staticRenderFns } from "./NotifyForm.vue?vue&type=template&id=01253a34&scoped=true&"
import script from "./NotifyForm.vue?vue&type=script&lang=js&"
export * from "./NotifyForm.vue?vue&type=script&lang=js&"
import style0 from "./NotifyForm.vue?vue&type=style&index=0&id=01253a34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01253a34",
  null
  
)

export default component.exports